// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-select-container-CnKq1 {
  width: 100%;
  position: relative;
  --top-popup: 52px;
}

.product-select-label-F8jOo {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.product-select-content-OF7r9 {
  width: 100%;
  height: 44px;
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 15px;
  color: #666666;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  padding: 0px 12px;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.product-select-content-OF7r9:focus-within { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.product-select-icon-vHB7V {
  display: block;
  --size: 24px;
  flex-shrink: 0;
}

.product-select-image-Xp2Zv {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.product-select-input-tt6Bn {
  height: 100%;
  width: 100%;
  display: block;
  flex-grow: 1;
  flex-grow: 1;
  font-size: 15px;
  font-family: Roboto;
  border: none;
  border-radius: 4px;
  outline: none;
  padding: 0px;
}

.product-select-input-tt6Bn::placeholder {
  color: var(--color-neutral-500);
}

.product-select-rightIcon-yx7Mj {
  --size: 22px;
  flex-shrink: 0;
}

.product-select-active-CGTkx {
  color: black;
  font-size: 15px;
}

.product-select-value-Tacpa {
  flex: 1;
}

.product-select-popup-zKRzS {
  max-height: 224px;
  background-color: white;
  overflow: auto;
}

.product-select-option_container-s1wql {
  display: flex;
  align-items: center;
  padding: 12px;
}

.product-select-optionImage-jLybE {
  width: 32px;
  height: 32px;
}

.product-select-optionInfo-XQMrs {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
}

.product-select-optionName-y9l_1 {
  display: block;
  margin-left: 24px;
}

.product-select-optionType-QJ2e7 {
  width: 72px;
  font-size: 15px;
  color: #555555;
}
`, "",{"version":3,"sources":["webpack://./src/components/product-select/product-select.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB","sourcesContent":[".container {\n  width: 100%;\n  position: relative;\n  --top-popup: 52px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.content {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  font-size: 15px;\n  color: #666666;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  padding: 0px 12px;\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.content:focus-within { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.icon {\n  display: block;\n  --size: 24px;\n  flex-shrink: 0;\n}\n\n.image {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n}\n\n.input {\n  height: 100%;\n  width: 100%;\n  display: block;\n  flex-grow: 1;\n  flex-grow: 1;\n  font-size: 15px;\n  font-family: Roboto;\n  border: none;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px;\n}\n\n.input::placeholder {\n  color: var(--color-neutral-500);\n}\n\n.rightIcon {\n  --size: 22px;\n  flex-shrink: 0;\n}\n\n.active {\n  color: black;\n  font-size: 15px;\n}\n\n.value {\n  flex: 1;\n}\n\n.popup {\n  max-height: 224px;\n  background-color: white;\n  overflow: auto;\n}\n\n.option_container {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n}\n\n.optionImage {\n  width: 32px;\n  height: 32px;\n}\n\n.optionInfo {\n  flex-grow: 1;\n  display: flex;\n  justify-content: space-between;\n}\n\n.optionName {\n  display: block;\n  margin-left: 24px;\n}\n\n.optionType {\n  width: 72px;\n  font-size: 15px;\n  color: #555555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product-select-container-CnKq1`,
	"label": `product-select-label-F8jOo`,
	"content": `product-select-content-OF7r9`,
	"icon": `product-select-icon-vHB7V`,
	"image": `product-select-image-Xp2Zv`,
	"input": `product-select-input-tt6Bn`,
	"rightIcon": `product-select-rightIcon-yx7Mj`,
	"active": `product-select-active-CGTkx`,
	"value": `product-select-value-Tacpa`,
	"popup": `product-select-popup-zKRzS`,
	"option_container": `product-select-option_container-s1wql`,
	"optionImage": `product-select-optionImage-jLybE`,
	"optionInfo": `product-select-optionInfo-XQMrs`,
	"optionName": `product-select-optionName-y9l_1`,
	"optionType": `product-select-optionType-QJ2e7`
};
export default ___CSS_LOADER_EXPORT___;
